












import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { INPUT_PROPS } from "@/const";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "InputPassword",
  components: { BaseInput },
  props: {
    ...INPUT_PROPS,
    fieldClass: {
      type: [String, Object, Array] as PropType<
        string | Record<string, boolean> | (string | Record<string, boolean>)[]
      >,
    },
    forceDark: { type: Boolean, default: false },
  },
  setup() {
    const secure = ref(true);
    const passwordIcon = computed(() => (secure.value ? "sci-eye-off" : "sci-eye"));

    return {
      secure,
      passwordIcon,
    };
  },
});
